<template>
  <div class="Exam-Questions">
    <div v-if="isQuestions" class="Exam-Questions-Main">
      <form v-on:submit.prevent>
        <div class="MobileDevice">
          <div class="Exam-Question-Header">
            <div class="Exam-Question-Header-Exam">
              <span>{{ExamQuestAnswer.bookedExamSingle[curpaper].bookedexams.examinations.shortdescription}}</span>
            </div>
            <div class="Exam-Question-Header-UserName">
              <span>{{Exam.UserFullName}}</span>
            </div>
          </div>
          <div class="Exam-Timer">
            <div class="Exam-Timer-Sub1">
              <span>Question No : {{queNo[curpaper]}}</span>
            </div>
            <div class="Exam-Timer-Sub2">
              <span>Time Remaining : </span><span class="Timer-Sub2"><b>{{ExamTimer}}</b></span>
            </div>
          </div>
          <div class="Exam-Questions-Number">
            <div class="Questions-Number-Sub1">
              <span> Select Question : </span>
            </div>
            <div class="Questions-Number-Sub2">
              <select v-model="queNo[curpaper]" @change="handleQuestionChange">
                <option v-for="(item, indx) in queSEL[curpaper]" v-bind:value="item" :key="indx" id="questNo">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
          <div class="IsMessageBox" v-if="isMsgWait[curpaper]">
            <div v-if="isImageAndText(ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].ismsgimage, ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].message)" class="ImageTextMessageDisplay">
              <div class="IsMessageInnerBox" v-html="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].message">
              </div>
              <div class="IsMessageInnerBox">
                <img :src="messageURL[curpaper]" :width="msgImgwidth" :height="msgImgheight"/>
              </div>
            </div>
            <div v-else-if="isMessageImage" class="IsMessageInnerBox">
              <img :src="messageURL[curpaper]" :width="msgImgwidth" :height="msgImgheight"/>
            </div>
            <div v-else class="IsMessageInnerBox" v-html="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].message">
            </div>
            <div class="BeforeFooter"></div>
          </div>
          <div class="Exam-Question-Details" v-if="!isMsgWait[curpaper]">
            <div v-if="isImageAndText(ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].isimage, ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question)" class="ImageTextDisplay">
              <div v-if="isMathEqu(ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question)" class="Question-Text-Box-Double">
                <vuemathjax :formula="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question"></vuemathjax>
              </div>
              <div v-else class="Question-Text-Box-Double" v-html="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question">
              </div>
              <div class="Question-Image-Box-Double">
                <img :src="questionURL[curpaper]"/>
              </div>
            </div>
            <div v-else-if="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].isimage" class="Question-Image-Box">
              <img :src="questionURL[curpaper]"/>
            </div>
            <div v-else>
              <div v-if="isMathEqu(ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question)" class="Question-Text-Box">
                <vuemathjax :formula="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question"></vuemathjax>
              </div>
              <div v-else class="Question-Text-Box" v-html="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question">
              </div>
            </div>
          </div>
          <div v-if="!isMsgWait[curpaper]">
            <div v-if="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].multipleanswer" class="Exam-Answers">
              <div v-if="isAnswerImage[curpaper]" :class="[{'AnswerImageSix': isSixAnswer}, 'AnswerImage']">
                <div class="AnswerOneTab">
                  <table v-if="buckets[curpaper].First > 0" class="AnswerTable">
                    <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="idx < buckets[curpaper].First" :key="idx">
                      <th><label>{{arec.ansorder}}.</label></th>
                      <td><input type="checkbox" :id="arec.ansorder" v-model="ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]][idx].answers"/></td>
                      <td v-if="arec.isimage" id="anschoice">
                        <div class="Answer-Image-Box">
                          <img :src="answersURL[curpaper][idx]"/>
                        </div>
                      </td>
                      <td v-else>
                        <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                          <vuemathjax :formula="arec.choices"></vuemathjax>
                        </div>
                        <div v-else class="Answer-Text-Box" v-html="arec.choices">
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="AnswerTwoTab">
                  <table v-if="buckets[curpaper].Second > 0" class="AnswerTable">
                    <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="getAnswerBoxTwo(idx)" :key="idx">
                      <th><label>{{arec.ansorder}}.</label></th>
                      <td><input type="checkbox" :id="arec.ansorder" v-model="ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]][idx].answers" /></td>
                      <td v-if="arec.isimage" id="anschoice">
                        <div class="Answer-Image-Box">
                          <img :src="answersURL[curpaper][idx]"/>
                        </div>
                      </td>
                      <td v-else>
                        <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                          <vuemathjax :formula="arec.choices"></vuemathjax>
                        </div>
                        <div v-else class="Answer-Text-Box" v-html="arec.choices">
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="AnswerThreeTab">
                  <table v-if="buckets[curpaper].Third > 0" class="AnswerTable">
                    <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="getAnswerBoxThree(idx)" :key="idx">
                      <th><label>{{arec.ansorder}}.</label></th>
                      <td><input type="checkbox" :id="arec.ansorder" v-model="ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]][idx].answers"/></td>
                      <td v-if="arec.isimage" id="anschoice">
                        <div class="Answer-Image-Box">
                          <img :src="answersURL[curpaper][idx]"/>
                        </div>
                      </td>
                      <td v-else>
                        <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                          <vuemathjax :formula="arec.choices"></vuemathjax>
                        </div>
                        <div v-else class="Answer-Text-Box" v-html="arec.choices">
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div v-else class="AnswerNonImage">
                <br/>
                <table class="AnswerTable">
                  <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" :key="idx">
                    <th><label>{{arec.ansorder}}.</label></th>
                    <td><input type="checkbox" :id="arec.ansorder" v-model="ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]][idx].answers" /></td>
                    <td><span v-html="arec.choices"></span></td>
                  </tr>
                </table>
              </div>
              <div class="BeforeFooter"></div>
            </div>
            <div v-else class="Exam-Answers">
              <div v-if="isAnswerImage[curpaper]" :class="[{'AnswerImageSix': isSixAnswer}, 'AnswerImage']">
                <div class="AnswerOneTab">
                  <table v-if="buckets[curpaper].First > 0" class="AnswerTable">
                    <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="idx < buckets[curpaper].First" :key="idx">
                      <th><label>{{arec.ansorder}}.</label></th>
                      <td><input type="radio" :id="arec.ansorder" :value="idx" v-model="radioChecked[curpaper][queNo[curpaper]]"/></td>
                      <td v-if="arec.isimage" id="anschoice">
                        <div class="Answer-Image-Box">
                          <img :src="answersURL[curpaper][idx]"/>
                        </div>
                      </td>
                      <td v-else>
                        <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                          <vuemathjax :formula="arec.choices"></vuemathjax>
                        </div>
                        <div v-else class="Answer-Text-Box" v-html="arec.choices">
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="AnswerTwoTab">
                  <table v-if="buckets[curpaper].Second > 0" class="AnswerTable">
                    <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="getAnswerBoxTwo(idx)" :key="idx">
                      <th><label>{{arec.ansorder}}.</label></th>
                      <td><input type="radio" :id="arec.ansorder" :value="idx" v-model="radioChecked[curpaper][queNo[curpaper]]"/></td>
                      <td v-if="arec.isimage" id="anschoice">
                        <div class="Answer-Image-Box">
                          <img :src="answersURL[curpaper][idx]"/>
                        </div>
                      </td>
                      <td v-else>
                        <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                          <vuemathjax :formula="arec.choices"></vuemathjax>
                        </div>
                        <div v-else class="Answer-Text-Box" v-html="arec.choices">
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="AnswerThreeTab">
                  <table v-if="buckets[curpaper].Third > 0" class="AnswerTable">
                    <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="getAnswerBoxThree(idx)" :key="idx">
                      <th><label>{{arec.ansorder}}.</label></th>
                      <td><input type="radio" :id="arec.ansorder" :value="idx" v-model="radioChecked[curpaper][queNo[curpaper]]"/></td>
                      <td v-if="arec.isimage" id="anschoice">
                        <div class="Answer-Image-Box">
                          <img :src="answersURL[curpaper][idx]"/>
                        </div>
                      </td>
                      <td v-else>
                        <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                          <vuemathjax :formula="arec.choices"></vuemathjax>
                        </div>
                        <div v-else class="Answer-Text-Box" v-html="arec.choices">
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div v-else class="AnswerNonImage">
                <br/>
                <table class="AnswerTable">
                  <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" :key="idx">
                    <th><label>{{arec.ansorder}}.</label></th>
                    <td><input type="radio" :id="arec.ansorder" :value="idx" v-model="radioChecked[curpaper][queNo[curpaper]]"/></td>
                    <td><span v-html="arec.choices"></span></td>
                  </tr>
                </table>
              </div>
              <div class="BeforeFooter"></div>
            </div>
          </div>
          <div class="SecondFooter">
            <div class="InnerSecondFooter">
              <div class="Exam-Submit">
                <input type="button" class="RespSubmit" @click="handleExamEndSubmit" name="submit" value="Submit"/>
              </div>
              <div class="Exam-Previous-Next">
                <input type="button" @click="PreviousQuestion" class="RespPrevious" name="previous" value="Previous"/>
                <input type="button" @click="NextQuestion" class="RespNext" name="next" value="Next"/>
              </div>
            </div>
          </div>
        </div>
        <div class="HigherDevice">
          <table>
            <tr>
              <td>
                <div class="Exam-Header-Name">
                  <span>Question No : {{queNo[curpaper]}}</span>
                </div>
              </td>
              <td>
                <div class="Exam-Question-Header">
                  <div class="Exam-Question-Header-Exam">
                    <span>{{ExamQuestAnswer.bookedExamSingle[curpaper].bookedexams.examinations.shortdescription}}</span>
                  </div>
                  <div class="Exam-Question-Header-UserName">
                    <span>{{Exam.UserFullName}}</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="Exam-Timer-Brandlogo">
                  <img class="BrandLogo-image" border="0" alt="..." src="@/assets/brandlogo.png" width="180" height="60" />
                </div>
                <div class="Exam-Questions-Number">
                  <br/>
                  <br/>
                  <label> Select Question </label><br/>
                  <div>
                    <select v-model="queNo[curpaper]" @change="handleQuestionChange">
                      <option v-for="(item, indx) in queSEL[curpaper]" v-bind:value="item" :key="indx" id="questNo">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <td v-if="isMsgWait[curpaper]" rowspan="2">
                <div class="IsMessageBox">
                  <div v-if="isImageAndText(ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].ismsgimage, ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].message)" class="ImageTextMessageDisplay">
                    <div class="IsMessageInnerBox" v-html="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].message">
                    </div>
                    <div class="IsMessageInnerBox">
                      <img :src="messageURL[curpaper]" :width="msgImgwidth" :height="msgImgheight"/>
                    </div>
                  </div>
                  <div v-else-if="isMessageImage" class="IsMessageInnerBox">
                    <img :src="messageURL[curpaper]" :width="msgImgwidth" :height="msgImgheight"/>
                  </div>
                  <div v-else class="IsMessageInnerBox" v-html="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].message">
                  </div>
                </div>
              </td>
              <td v-if="!isMsgWait[curpaper]">
                <div class="Exam-Question-Details">
                  <div v-if="isImageAndText(ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].isimage, ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question)" class="ImageTextDisplay">
                    <div v-if="isMathEqu(ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question)" class="Question-Text-Box-Double">
                      <vuemathjax :formula="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question"></vuemathjax>
                    </div>
                    <div v-else class="Question-Text-Box-Double" v-html="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question">
                    </div>
                    <div class="Question-Image-Box-Double">
                      <img :src="questionURL[curpaper]"/>
                    </div>
                  </div>
                  <div v-else-if="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].isimage" class="Question-Image-Box">
                    <img :src="questionURL[curpaper]"/>
                  </div>
                  <div v-else>
                    <div v-if="isMathEqu(ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question)" class="Question-Text-Box">
                      <vuemathjax :formula="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question"></vuemathjax>
                    </div>
                    <div v-else class="Question-Text-Box" v-html="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].question">
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="Exam-Timer">
                  <p>Time Remaining</p>
                  <h1>{{ExamTimer}}</h1>
                </div>
              </td>
              <td v-if="!isMsgWait[curpaper]">
                <div v-if="ExamQuestAnswer.bookedExamSingle[curpaper].questions[queNo[curpaper]].multipleanswer" class="Exam-Answers">
                  <div v-if="isAnswerImage[curpaper]" class="AnswerImage">
                    <div class="AnswerOneTab">
                      <table v-if="buckets[curpaper].First > 0" class="AnswerTable">
                        <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="idx < buckets[curpaper].First" :key="idx">
                          <th><label>{{arec.ansorder}}.</label></th>
                          <td><input type="checkbox" :id="arec.ansorder" v-model="ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]][idx].answers" /></td>
                          <td v-if="arec.isimage" id="anschoice">
                            <div class="Answer-Image-Box">
                              <img :src="answersURL[curpaper][idx]"/>
                            </div>
                          </td>
                          <td v-else>
                            <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                              <vuemathjax :formula="arec.choices"></vuemathjax>
                            </div>
                            <div v-else class="Answer-Text-Box" v-html="arec.choices">
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="AnswerTwoTab">
                      <table v-if="buckets[curpaper].Second > 0" class="AnswerTable">
                        <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="getAnswerBoxTwo(idx)" :key="idx">
                          <th><label>{{arec.ansorder}}.</label></th>
                          <td><input type="checkbox" :id="arec.ansorder" v-model="ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]][idx].answers" /></td>
                          <td v-if="arec.isimage" id="anschoice">
                            <div class="Answer-Image-Box">
                              <img :src="answersURL[curpaper][idx]"/>
                            </div>
                          </td>
                          <td v-else>
                            <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                              <vuemathjax :formula="arec.choices"></vuemathjax>
                            </div>
                            <div v-else class="Answer-Text-Box" v-html="arec.choices">
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="AnswerThreeTab">
                      <table v-if="buckets[curpaper].Third > 0" class="AnswerTable">
                        <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="getAnswerBoxThree(idx)" :key="idx">
                          <th><label>{{arec.ansorder}}.</label></th>
                          <td><input type="checkbox" :id="arec.ansorder" v-model="ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]][idx].answers"/></td>
                          <td v-if="arec.isimage" id="anschoice">
                            <div class="Answer-Image-Box">
                              <img :src="answersURL[curpaper][idx]"/>
                            </div>
                          </td>
                          <td v-else>
                            <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                              <vuemathjax :formula="arec.choices"></vuemathjax>
                            </div>
                            <div v-else class="Answer-Text-Box" v-html="arec.choices">
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div v-else class="AnswerNonImage">
                    <br/>
                    <table class="AnswerTable">
                      <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" :key="idx">
                        <th><label>{{arec.ansorder}}.</label></th>
                        <td><input type="checkbox" :id="arec.ansorder" v-model="ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]][idx].answers" /></td>
                        <td><span v-html="arec.choices"></span></td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div v-else class="Exam-Answers">
                  <div v-if="isAnswerImage[curpaper]" class="AnswerImage">
                    <div class="AnswerOneTab">
                      <table v-if="buckets[curpaper].First > 0" class="AnswerTable">
                        <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="idx < buckets[curpaper].First" :key="idx">
                          <th><label>{{arec.ansorder}}.</label></th>
                          <td><input type="radio" :id="arec.ansorder" :value="idx" v-model="radioChecked[curpaper][queNo[curpaper]]"/></td>
                          <td v-if="arec.isimage" id="anschoice">
                            <div class="Answer-Image-Box">
                              <img :src="answersURL[curpaper][idx]"/>
                            </div>
                          </td>
                          <td v-else>
                            <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                              <vuemathjax :formula="arec.choices"></vuemathjax>
                            </div>
                            <div v-else class="Answer-Text-Box" v-html="arec.choices">
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="AnswerTwoTab">
                      <table v-if="buckets[curpaper].Second > 0" class="AnswerTable">
                        <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="getAnswerBoxTwo(idx)" :key="idx">
                          <th><label>{{arec.ansorder}}.</label></th>
                          <td><input type="radio" :id="arec.ansorder" :value="idx" v-model="radioChecked[curpaper][queNo[curpaper]]"/></td>
                          <td v-if="arec.isimage" id="anschoice">
                            <div class="Answer-Image-Box">
                              <img :src="answersURL[curpaper][idx]"/>
                            </div>
                          </td>
                          <td v-else>
                            <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                              <vuemathjax :formula="arec.choices"></vuemathjax>
                            </div>
                            <div v-else class="Answer-Text-Box" v-html="arec.choices">
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="AnswerThreeTab">
                      <table v-if="buckets[curpaper].Third > 0" class="AnswerTable">
                        <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" v-if="getAnswerBoxThree(idx)" :key="idx">
                          <th><label>{{arec.ansorder}}.</label></th>
                          <td><input type="radio" :id="arec.ansorder" :value="idx" v-model="radioChecked[curpaper][queNo[curpaper]]"/></td>
                          <td v-if="arec.isimage" id="anschoice">
                            <div class="Answer-Image-Box">
                              <img :src="answersURL[curpaper][idx]"/>
                            </div>
                          </td>
                          <td v-else>
                            <div v-if="isMathEqu(arec.choices)" class="Answer-Text-Box">
                              <vuemathjax :formula="arec.choices"></vuemathjax>
                            </div>
                            <div v-else class="Answer-Text-Box" v-html="arec.choices">
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div v-else class="AnswerNonImage">
                    <br/>
                    <table class="AnswerTable">
                      <tr v-for="(arec, idx) in ExamQuestAnswer.bookedExamSingle[curpaper].answers[queNo[curpaper]]" :key="idx">
                        <th><label>{{arec.ansorder}}.</label></th>
                        <td><input type="radio" :id="arec.ansorder" :value="idx" v-model="radioChecked[curpaper][queNo[curpaper]]"/></td>
                        <td><span v-html="arec.choices"></span></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="Exam-Submit">
                  <input type="button" class="RespSubmit" @click="handleExamEndSubmit" name="submit" value="Submit"/>
                </div>
              </td>
              <td>
                <div class="Exam-Previous-Next">
                  <input type="button" @click="PreviousQuestion" class="RespPrevious" name="previous" value="Previous"/>
                  <input type="button" @click="NextQuestion" class="RespNext" name="next" value="Next"/>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </form>
    </div>
    <div v-if="LoadMessage" class="FirstOverlay">
    </div>
    <PageDialog v-if="LoadMessage"/>
    <div v-if="waitforResult" class="WaitMessageBox">
      <WaitResult :shortdescr="Exam.Examination.shortdescription" :waitMessage="waitMessage"/>
    </div>
    <div v-if="produceResult">
      <prepareResult :ResultDetails="ResultDetails" :Exam="Exam"/>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import {VueMathjax} from 'vue-mathjax'
import WaitResult from '@/components/WaitResult.vue'
import prepareResult from '@/components/prepareResult.vue'
import PageDialog from '@/components/PageDialog.vue'

export default {
  name: 'ExamQuestions',
  props: ['server', 'Exam', 'ExQuestion', 'userid'],
  components: {WaitResult, prepareResult, 'vuemathjax': VueMathjax, PageDialog},
  data () {
    return {
      queNo: [],
      queSEL: [],
      ExamQuestAnswer: this.ExQuestion,
      radioChecked: [],
      ExamTimer: this.ExQuestion.timeRemain,
      ResultDetails: {MainBooking: '', ExamBooking: ''},
      produceResult: false,
      waitforResult: false,
      isQuestions: true,
      vLoginResponse: '',
      vconnectError: '',
      msgType: '',
      httpStatus: '',
      totquest: [],
      waitMessage: '',
      buckets: [],
      questionURL: [],
      answersURL: [],
      messageURL: [],
      isAnswerImage: [],
      isMsgWait: [],
      msgImgheight: 424,
      msgImgwidth: 1070,
      mobwidth: false,
      padwidth: false
    }
  },
  created: function () {
    var PapList = []
    this.timer = setInterval(this.tick.bind(this), 2000)
    // console.log('singlePaperList :', this.ExamQuestAnswer.bookedExamSingle)
    // console.log('LengthPaperList :', this.ExamQuestAnswer.bookedExamSingle.length)
    for (var j = 0; j < this.ExamQuestAnswer.bookedExamSingle.length; j++) {
      var singlePaper = this.ExamQuestAnswer.bookedExamSingle[j]
      PapList.push(singlePaper.bookedexams.examinations.examcode)
      this.buckets.push({First: 0, Second: 0, Third: 0})
      this.queNo.push(1)
      this.isAnswerImage.push(false)
      this.questionURL.push('')
      this.messageURL.push('')
      this.answersURL.push([])
      this.queSEL.push([])
      this.radioChecked.push([''])
      this.totquest.push(0)
      this.isMsgWait.push(false)
      if ((singlePaper.bookedexams.examinations.totalquestions !== '') && (this.queSEL[j].length === 0)) {
        for (var i = 0; i < parseInt(singlePaper.bookedexams.examinations.totalquestions); i++) {
          this.queSEL[j].push(i + 1)
          this.radioChecked[j].push('')
        }
        this.totquest[j] = this.queSEL[j].length
      }
    }
    this.$store.commit('setPaperList', {Papers: PapList})
    console.log('PapList :', PapList)
    console.log('buckets :', this.buckets)
    console.log('queNo :', this.queNo)
    console.log('isAnswerImage :', this.isAnswerImage)
    console.log('queSEL :', this.queSEL)
    console.log('totquest :', this.totquest)
    console.log('questionURL :', this.questionURL)
    console.log('answersURL :', this.answersURL)
    console.log('isMessage :', this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].ismessage)
    if (this.isMessage()) {
      this.isMsgWait[this.curpaper] = true
    }
    console.log('isMsgWait :', this.isMsgWait)
    this.stateUpdate()
  },
  mounted: function () {
    window.addEventListener('keydown', this.handleKeyPress)
    window.addEventListener('resize', this.handleScreenSize)
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },
  computed: {
    curpaper: function () {
      return this.$store.state.CurrPaper
    },
    isMessageImage: function () {
      return this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].ismsgimage
    },
    LoadMessage: function () {
      return this.$store.state.LoadDialog
    },
    SendExam: function () {
      return this.$store.state.SubmitExam
    },
    isSixAnswer: function () {
      console.log('Total Boxes :', (this.buckets[this.curpaper].First + this.buckets[this.curpaper].Second + this.buckets[this.curpaper].Third))
      return (this.buckets[this.curpaper].First + this.buckets[this.curpaper].Second + this.buckets[this.curpaper].Third) > 4
    }
  },
  watch: {
    SendExam: function (newval, oldval) {
      if (newval) {
        this.waitMessage = 'Exam Submitted, Waiting For Result....Wait'
        this.handleConfirmed()
      }
    }
  },
  methods: {
    isDevMaxWidth: function (mobdevice) {
      if (mobdevice === 'Phone') {
        this.msgImgheight = 141
        this.msgImgwidth = 357
        return this.mobwidth
      } else if (mobdevice === 'Pad') {
        this.msgImgheight = 212
        this.msgImgwidth = 535
        return this.padwidth
      } else {
        this.msgImgheight = 424
        this.msgImgwidth = 1070
        return false
      }
    },
    isMathEqu: function (varparm) {
      if ((varparm.includes('\\(') && varparm.includes('\\)')) || (varparm.includes('\\[') && varparm.includes('\\]')) || (varparm.includes('\\ce{') && varparm.includes('}'))) {
        return true
      } else {
        return false
      }
    },
    isImageAndText: function (isimg, istext) {
      return (isimg && istext.trim().length !== 0)
    },
    handleKeyPress: function (evt) {
      const keyCode = String(evt.keyCode || evt.code || evt.keyIdentifier)
      if (keyCode === '78') {
        this.NextQuestion()
      } else if (keyCode === '80') {
        this.PreviousQuestion()
      } else if (keyCode === '83') {
        this.handleExamEndSubmit()
      } else if (keyCode === '82') {
        this.handleExamEndSubmit()
      } else if (this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].multipleanswer) {
        if (!this.isMsgWait[this.curpaper]) {
          const arrsize = this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]].length
          if ((keyCode === '65') && (arrsize > 0)) {
          } else if ((keyCode === '66') && (arrsize > 1)) {
          } else if ((keyCode === '67') && (arrsize > 2)) {
          } else if ((keyCode === '68') && (arrsize > 3)) {
          } else if ((keyCode === '69') && (arrsize > 4)) {
          } else if ((keyCode === '70') && (arrsize > 5)) {
          }
        }
      } else {
        if (!this.isMsgWait[this.curpaper]) {
          const arrsize = this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]].length
          if ((keyCode === '65') && (arrsize > 0)) {
            this.radioChecked[this.curpaper][this.queNo[this.curpaper]] = 0
          } else if ((keyCode === '66') && (arrsize > 1)) {
            this.radioChecked[this.curpaper][this.queNo[this.curpaper]] = 1
          } else if ((keyCode === '67') && (arrsize > 2)) {
            this.radioChecked[this.curpaper][this.queNo[this.curpaper]] = 2
          } else if ((keyCode === '68') && (arrsize > 3)) {
            this.radioChecked[this.curpaper][this.queNo[this.curpaper]] = 3
          } else if ((keyCode === '69') && (arrsize > 4)) {
            this.radioChecked[this.curpaper][this.queNo[this.curpaper]] = 4
          } else if ((keyCode === '70') && (arrsize > 5)) {
            this.radioChecked[this.curpaper][this.queNo[this.curpaper]] = 5
          }
        }
      }
    },
    handleScreenSize: function (evt) {
      this.mobwidth = window.matchMedia('screen and (max-width:414px)').matches
      this.padwidth = window.matchMedia('screen and (min-width:415px) and (max-width:868px)').matches
      if (this.mobwidth || this.padwidth) {
        this.$store.commit('setShowFooter', {shwfooter: false})
      } else {
        this.$store.commit('setShowFooter', {shwfooter: true})
      }
      // console.log('Screen Change To Mobile :', this.devwidth)
    },
    isMessage: function () {
      return this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].ismessage
    },
    stateUpdate: function () {
      this.updateAnswerImage()
      this.updateImageURL()
      if (this.isAnswerImage[this.curpaper]) {
        this.AnswerUpdate()
      }
    },
    getAnswerBoxTwo: function (ndx) {
      return (ndx >= this.buckets[this.curpaper].First) && (ndx < (this.buckets[this.curpaper].First + this.buckets[this.curpaper].Second))
    },
    getAnswerBoxThree: function (ndx) {
      return (ndx >= (this.buckets[this.curpaper].First + this.buckets[this.curpaper].Second)) && (ndx < (this.buckets[this.curpaper].First + this.buckets[this.curpaper].Second + this.buckets[this.curpaper].Third))
    },
    AnswerUpdate () {
      this.buckets[this.curpaper].First = 0
      this.buckets[this.curpaper].Second = 0
      this.buckets[this.curpaper].Third = 0
      const anslength = this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]].length
      if ((anslength === 1) || (anslength === 2)) {
        this.buckets[this.curpaper].First = (anslength === 1) ? 1 : 2
      }
      if ((anslength === 3) || (anslength === 4)) {
        this.buckets[this.curpaper].First = 2
        this.buckets[this.curpaper].Second = (anslength === 3) ? 1 : 2
      }
      if ((anslength === 5) || (anslength === 6)) {
        this.buckets[this.curpaper].First = 2
        this.buckets[this.curpaper].Second = 2
        this.buckets[this.curpaper].Third = (anslength === 5) ? 1 : 2
      }
    },
    updateAnswerImage: function () {
      for (var i = 0; i < this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]].length; i++) {
        if (this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]][i].isimage || this.isMathEqu(this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]][i].choices)) {
          this.isAnswerImage[this.curpaper] = true
          break
        } else {
          this.isAnswerImage[this.curpaper] = false
        }
      }
    },
    updateImageURL: function () {
      this.questionURL[this.curpaper] = (this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].isimage) ? 'data:image/png;base64,' + this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].questionimage : ''
      if (this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].ismsgimage) {
        this.messageURL[this.curpaper] = 'data:image/png;base64,' + this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].messageimage
        const msgsize = this.ExamQuestAnswer.bookedExamSingle[this.curpaper].questions[this.queNo[this.curpaper]].msgimagesize.split('|')
        const msgheight = parseInt(msgsize[0], 10)
        const msgwidth = parseInt(msgsize[1], 10)
        var baseheight = this.msgImgheight
        if (msgheight < (this.msgImgheight / 2)) {
          baseheight = (this.msgImgheight / 2)
        }
        const sizratio = (msgwidth / msgheight)
        this.msgImgheight = baseheight
        this.msgImgwidth = baseheight * sizratio
      } else {
        this.messageURL[this.curpaper] = ''
      }
      if (this.isAnswerImage[this.curpaper]) {
        for (var i = 0; i < this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]].length; i++) {
          this.answersURL[this.curpaper][i] = (this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]][i].isimage) ? 'data:image/png;base64,' + this.ExamQuestAnswer.bookedExamSingle[this.curpaper].answers[this.queNo[this.curpaper]][i].choicesimage : ''
        }
      }
    },
    showSpinner (showflag) {
      this.$emit('runSpinner', showflag)
    },
    tick () {
      if (this.ExamTimer !== 'TimeOut') {
        const url = this.server.htp + '://' + this.server.IP + ':' + this.server.Port + this.server.Webapp + 'Booking/timer/' + this.ExamQuestAnswer.bookedexams.id
        fetch(url, {
          mode: 'cors',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + this.$store.state.auth.token
          }
        }).then(res => res.json())
          .then(response => {
            this.ExamTimer = response.TimeRemaining
          })
          .catch(error => {
            this.vconnectError = error
          })
      }
      if ((this.ExamTimer === 'TimeOut') && (this.waitMessage === '')) {
        this.waitMessage = 'Time Up!! Exam Auto-Submission, Waiting For Result....Wait'
        this.handleConfirmed()
      }
    },
    NextQuestion: function () {
      if (this.isMsgWait[this.curpaper]) {
        Vue.set(this.isMsgWait, this.curpaper, false)
      } else {
        Vue.set(this.queNo, this.curpaper, Math.min(this.queNo[this.curpaper] + 1, this.totquest[this.curpaper]))
        if (this.isMessage()) {
          Vue.set(this.isMsgWait, this.curpaper, true)
        }
        this.stateUpdate()
      }
    },
    PreviousQuestion: function () {
      Vue.set(this.queNo, this.curpaper, Math.max(this.queNo[this.curpaper] - 1, 1))
      if (this.isMessage()) {
        Vue.set(this.isMsgWait, this.curpaper, true)
      } else {
        Vue.set(this.isMsgWait, this.curpaper, false)
      }
      this.stateUpdate()
    },
    handleQuestionChange: function () {
      if (this.isMessage()) {
        Vue.set(this.isMsgWait, this.curpaper, true)
      } else {
        Vue.set(this.isMsgWait, this.curpaper, false)
      }
      this.stateUpdate()
    },
    handleExamEndSubmit: function () {
      this.$store.commit('setLoadDialog', {DialogLoad: true})
    },
    handleConfirmed: function () {
      this.showSpinner(true)
      this.isRespMsg = false
      this.isErrorMsg = false
      this.waitforResult = true
      this.isQuestions = false
      // console.log('Send-Exam-Request :', this.ExamQuestAnswer)
      this.$store.commit('onSpinner')
      const url = this.server.htp + '://' + this.server.IP + ':' + this.server.Port + this.server.Webapp + 'Booking/update/' + this.ExamQuestAnswer.bookedexams.id
      for (var j = 0; j < this.radioChecked.length; j++) {
        for (var k = 0; k < this.radioChecked[j].length; k++) {
          if (this.radioChecked[j][k] !== '') {
            this.ExamQuestAnswer.bookedExamSingle[j].answers[k][this.radioChecked[j][k]].answers = true
          }
        }
        // console.log('Request-Answers ' + j + ' :', this.ExamQuestAnswer.bookedExamSingle[j].answers)
      }
      // console.log('Send-Exam-Request :', this.ExamQuestAnswer)
      this.$store.commit('setPaperList', {Papers: []})
      fetch(url, {
        mode: 'cors',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + this.$store.state.auth.token
        },
        body: JSON.stringify(this.ExamQuestAnswer)
      }).then(res => {
        this.httpStatus = res.status
        return res.json()
      }).then(response => {
        // console.log('Submited-Exam-Response :', response)
        this.$store.commit('offSpinner')
        if (this.httpStatus === 403) {
          this.vconnectError = 'Access to Resource is Denied'
          this.isErrorMsg = true
          this.msgType = 'ERR'
        } else if ((response.Response !== undefined) && (response.Response.includes('Success'))) {
          this.produceResult = true
          this.waitforResult = false
          this.ResultDetails.MainBooking = response.MainBooking
          this.ResultDetails.ExamBooking = response.ExamBooking
        } else if (response.Response === undefined) {
          this.vconnectError = 'Server Error!!!'
          this.isErrorMsg = true
          this.msgType = 'ERR'
        } else {
          this.vLoginResponse = response.Response
          this.isRespMsg = true
          this.msgType = 'MSG'
        }
      })
        .catch(error => {
          this.$store.commit('offSpinner')
          console.log('Submited-Exam-Error :', error)
          this.vconnectError = 'Connection Error!!!'
          this.isErrorMsg = true
          this.msgType = 'ERR'
        })
    }
  }
}
</script>
<style scoped>
.Exam-Questions {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
  font-size: 15px;
}
.Exam-Questions-Main {
  background-color: #c3c3c3;
  height: 100%;
  width: 100%;
  float: left;
}
.Exam-Header-Name {
  background-color: #317082;
  color: white;
  height: 30px;
  width: 200px;
  line-height: 30px;
  text-align: center;
  float: left;
  border-radius: 5px;
}
.Exam-Timer-Brandlogo{
  height: 60px;
  width: 200px;
  border-bottom: 1px solid #c3c3c3;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}
.BrandLogo-image{
  height: 60px;
  width: 200px;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}
.Exam-Questions-Number {
  background-color: #FFFFFF;
  height: 170px;
  width: 200px;
  float: left;
}
.Exam-Questions-Number label {
  margin-left: 20px;
}
.Exam-Questions-Number select {
  margin-left: 20px;
  height: 20px;
  width: 70px;
}
.Exam-Timer {
  background-color: #FFFFFF;
  height: 210px;
  width: 200px;
  float: left;
}
.Exam-Timer p, .Exam-Timer h1 {
  margin-left: 20px;
}
.Exam-Submit{
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  justify-content: center;
}
.Exam-Submit-Box {
  height: 30px;
  width: 70px;
}
.Exam-Question-Header {
  background-color: #317082;
  color: white;
  height: 30px;
  width: 1100px;
  float: left;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
}
.Exam-Question-Header-UserName{
  flex: 1;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  align-items: center;
  justify-content: flex-end;
}
.Exam-Question-Header-Exam{
  flex: 1;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display: flex;
  align-items: center;
}
.Exam-Question-Header-Exam span {
  margin-left: 10px;
}
.Exam-Question-Header-UserName span {
  margin-right: 10px;
}
.IsMessageBox {
  height: 444px;
  width: 1100px;
  background-color: #FFFFFF;
  border-radius: 7px;
}
.IsMessageInnerBox {
  margin: 10px;
}
.ImageTextMessageDisplay {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:column;
  -ms-flex-direction:column;
  flex-direction:column;
}
.Exam-Question-Details {
  background-color: #FFFFFF;
  height: 230px;
  width: 1100px;
  float: left;
  border-radius: 7px;
}
.Exam-Question-Details img{
  width: 470px;
  height: 210px;
}
.Exam-Question-Details span,
.Exam-Answers label {
  margin-left: 10px;
}
.ImageTextDisplay {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
}
.Question-Text-Box-Double {
  flex: 1;
  margin: 10px;
}
.Question-Image-Box-Double {
  flex: 2;
}
.Question-Text-Box {
  margin: 10px;
}
.Answer-Image-Box,
.Answer-Text-Box,
.Question-Image-Box {
  border: 1px solid grey;
  border-radius: 7px;
}
.Exam-Answers {
  background-color: #FFFFFF;
  height: 210px;
  width: 1100px;
  float: left;
  border-radius: 7px;
}
.AnswerImage {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
}
.AnswerImage img {
  width: 230px;
  height: 95px;
}
.Answer-Image-Box,
.Answer-Text-Box,
.Question-Image-Box {
  border: 1px solid grey;
  border-radius: 7px;
}
.Answer-Text-Box {
  width: 230px;
  height: 95px;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  align-items: center;
}
.Answer-Text-Box  span{
  margin-left: 10px;
}
.Answer-Image-Box img,
.Question-Image-Box img {
  border-radius: 15px;
}
.Exam-Previous-Next input,
.Exam-Submit input{
  background-color: #395693;
  height: 25px;
  width: 70px;
  color: white;
  cursor: pointer;
  border-radius: 12px;
  outline-style: none;
}
@media screen and (min-width:1025px) {
  .MobileDevice {
    display: none;
    visibility: hidden;
  }
  .HigherDevice {
    display: block;
    visibility: visible;
  }
  .IsMessageBox {
    overflow-y: scroll;
  }
  .Exam-Question-Header {
    border-radius: 5px;
  }
  .Exam-Questions-Number {
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
  }
  .Exam-Timer {
    border-radius: 7px;
  }
}
@media screen and (min-width:641px) and (max-width:1024px) {
  .MobileDevice {
    display: block;
    visibility: visible;
  }
  .HigherDevice {
    display: none;
    visibility: hidden;
  }
  .Exam-Questions-Main {
    font-size: 12px;
    border-top: 3px solid #c3c3c3;
    border-left: 3px solid #c3c3c3;
    border-right: 3px solid #c3c3c3;
  }
  .Exam-Question-Header {
    background-color: #317082;
    color: white;
    height: 20px;
    width: 100%;
    float: left;
  }
  .Exam-Question-Header-Exam span {
    margin-left: 5px;
  }
  .Exam-Question-Header-UserName span {
    margin-right: 5px;
  }
  .Exam-Timer {
    background-color: #FFFFFF;
    height: 20px;
    width: 100%;
    border-top: 3px solid #c3c3c3;
    float: left;
    border-radius: none;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
  }
  .Exam-Questions-Number {
    background-color: #317082;
    border-top: 3px solid #c3c3c3;
    height: 20px;
    width: 100%;
    float: left;
    color: white;
    border-radius: none;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
  }
  .Exam-Questions-Number label {
    margin-left: 5px;
  }
  .Exam-Questions-Number select {
    margin-left: 5px;
    width: 70px;
  }
  .IsMessageBox,
  .Exam-Question-Details,
  .Exam-Answers  {
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
    border-top: 3px solid #c3c3c3;
    float: left;
  }
  .IsMessageBox,
  .Exam-Answers  {
    border-bottom: 3px solid #c3c3c3;
  }
  .Exam-Question-Details img{
    width: 235px;
    height: 105px;
  }
  .IsMessageInnerBox {
    margin: 5px;
  }
  .Exam-Question-Details span,
  .Exam-Answers label {
    margin-left: 5px;
  }
  .ImageTextDisplay {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
    display: flex;
  }
  .Question-Text-Box-Double,
  .Question-Image-Box-Double {
    flex: 1;
    margin: 5px;
  }
  .AnswerImage {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
    flex-wrap: wrap;
    height: 190px;
  }
  .AnswerImageSix {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
    flex-wrap: wrap;
    height: 285px;
  }
  .BeforeFooter {
    height: 10px;
  }
  .SecondFooter {
    height: 45px;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: gray;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display: flex;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
    align-items: center;
    justify-content: center;
  }
  .InnerSecondFooter {
    height: 25px;
    width: 100%;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display: flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
  }
  .Exam-Submit {
    flex: 1;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display: flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
    align-items: center;
    justify-content: flex-start;
  }
  .Exam-Previous-Next {
    flex: 2;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display: flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
    align-items: center;
    justify-content: flex-end;
  }
  .RespNext {
    margin-right: 5px;
  }
  .RespPrevious {
    margin-right: 10px;
  }
  .Exam-Previous-Next input,
  .Exam-Submit input{
    font-size: 13px;
    height: 25px;
    width: 70px;
    border-radius: 12px;
  }
}
@media screen and (max-width:640px) {
  .MobileDevice {
    display: block;
    visibility: visible;
  }
  .HigherDevice {
    display: none;
    visibility: hidden;
  }
  .Exam-Questions-Main {
    font-size: 12px;
    border-top: 3px solid #c3c3c3;
    border-left: 3px solid #c3c3c3;
    border-right: 3px solid #c3c3c3;
  }
  .Exam-Question-Header {
    background-color: #317082;
    color: white;
    height: 40px;
    width: 100%;
    float: left;
  }
  .Exam-Question-Header-Exam span {
    margin-left: 5px;
  }
  .Exam-Question-Header-UserName span {
    margin-right: 5px;
  }
  .Exam-Timer {
    background-color: #FFFFFF;
    height: 30px;
    width: 100%;
    border-top: 3px solid #c3c3c3;
    float: left;
    border-radius: none;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
  }
  .Exam-Questions-Number {
    background-color: #317082;
    border-top: 3px solid #c3c3c3;
    height: 20px;
    width: 100%;
    float: left;
    color: white;
    border-radius: none;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
  }
  .Exam-Questions-Number label {
    margin-left: 5px;
  }
  .Exam-Questions-Number select {
    margin-left: 5px;
    width: 70px;
  }
  .IsMessageBox,
  .Exam-Question-Details,
  .Exam-Answers  {
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
    border-top: 3px solid #c3c3c3;
    float: left;
  }
  .IsMessageBox,
  .Exam-Answers  {
    border-bottom: 3px solid #c3c3c3;
  }
  .Exam-Question-Details img{
    width: 235px;
    height: 105px;
  }
  .IsMessageInnerBox {
    margin: 5px;
  }
  .Exam-Question-Details span,
  .Exam-Answers label {
    margin-left: 5px;
  }
  .ImageTextDisplay {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
  }
  .Question-Text-Box-Double,
  .Question-Image-Box-Double {
    flex: 0;
    margin: 5px;
  }
  .AnswerImage {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
  }
  .AnswerImageSix {
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
  }
  .BeforeFooter {
    height: 10px;
  }
  .SecondFooter {
    height: 45px;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: gray;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display: flex;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
    align-items: center;
    justify-content: center;
  }
  .InnerSecondFooter {
    height: 25px;
    width: 100%;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display: flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
  }
  .Exam-Submit {
    flex: 1;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display: flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
    align-items: center;
    justify-content: flex-start;
  }
  .Exam-Previous-Next {
    flex: 2;
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display: flex;
    -webkit-flex-direction:row;
    -ms-flex-direction:row;
    flex-direction:row;
    align-items: center;
    justify-content: flex-end;
  }
  .RespNext {
    margin-right: 5px;
  }
  .RespPrevious {
    margin-right: 10px;
  }
  .Exam-Previous-Next input,
  .Exam-Submit input{
    font-size: 10px;
    height: 25px;
    width: 60px;
    border-radius: 12px;
  }
}
.Exam-Timer-Sub1 {
  flex: 1;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display: flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
  align-items: center;
  justify-content: flex-start;
}
.Exam-Timer-Sub2 {
  flex: 1;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display: flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
  align-items: center;
  justify-content: flex-end;
}
.Exam-Timer-Sub1 span{
  margin-left: 5px;
}
.Exam-Timer-Sub2 span{
  margin-right: 5px;
}
.Timer-Sub2 {
  font-size: 20px;
}
.Questions-Number-Sub1 {
  flex: 1;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display: flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
  align-items: center;
  justify-content: flex-start;
}
.Questions-Number-Sub1 span{
  margin-left: 5px;
}
.Questions-Number-Sub2 {
  flex: 2;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display: flex;
  -webkit-flex-direction:row;
  -ms-flex-direction:row;
  flex-direction:row;
  align-items: center;
  justify-content: flex-start;
}
.Exam-Previous-Next,
.Exam-Submit {
  height: 25px;
}
.Exam-Submit {
  display: flex;
  align-items: center;
}
.RespNext {
  float: right;
  margin-right: 10px;
}
.RespPrevious {
  margin-left: 10px;
  float: left;
}
.RespSubmit {
  margin-left: 10px;
  float: center;
}
.WaitMessageBox {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.FirstOverlay {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: gray;
  opacity: 0.6;
  z-index: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamQuestions.vue